import React, {FC} from 'react';
import SDCLogo from "../../../../img/SDCLogo.png";
import {PlayerInfo} from "../../../../store/pages/scoreboardAndStats/types";
import { getSeparateDisplayNames } from "../../../../helpers/getSeparateDisplayNames";

interface IPlayerCardProps {
    playerInfo: PlayerInfo
}

const PlayerCard: FC<IPlayerCardProps> = ({playerInfo}) => {
    return (
        <div className="player-card">
            <div className="player-card__logo">
                <img
                    alt="logo"
                    className="player-card__logo-img"
                    src={SDCLogo}
                />
            </div>
            {Object.keys(playerInfo).length > 0 && <div className="player-card-name">
                <h1 className="player-card-name__first-name">{getSeparateDisplayNames(playerInfo.name).name}</h1>
                <h1 className="player-card-name__last-name">{getSeparateDisplayNames(playerInfo.name).surname}</h1>
            </div>}
            <div className="player-card-info">
                <div className="panel-stats-item panel-stats-item-card">
                    <div>
                        <p className="panel-stats-title">AGE</p>
                    </div>
                    <div>
                        <p className="panel-stats-value panel-stats-value-card">
                            {playerInfo.age}
                        </p>
                    </div>
                </div>
                <div className="panel-stats-item panel-stats-item-card">
                    <div>
                        <p className="panel-stats-title">HOME TOWN</p>
                    </div>
                    <div>
                        <p className="panel-stats-value panel-stats-value-card">
                            {playerInfo.hometown}
                        </p>
                    </div>
                </div>
                <div className="panel-stats-item panel-stats-item-card">
                    <div>
                        <p className="panel-stats-title">DARTS USED</p>
                    </div>
                    <div>
                        <p className="panel-stats-value panel-stats-value-card">
                            {playerInfo.dartsUsed}
                        </p>
                    </div>
                </div>
                <div className="panel-stats-item panel-stats-item-card">
                    <div className="panel-stats-item-card-career">
                        <div className="panel-stats-title">
                            The best competition
                        </div>
                        <div className="panel-stats-value">
                            {playerInfo.careerBest}
                        </div>
                    </div>
                </div>
                {playerInfo.nickname && <div className="panel-stats-item panel-stats-item-card">
                    <div>
                        <p className="panel-stats-title">Nickname</p>
                    </div>
                    <div>
                        {
                            playerInfo.nickname && playerInfo.nickname.trim() &&
                            <p className="panel-stats-value panel-stats-value-card">{playerInfo.nickname}</p>
                        }
                    </div>
                </div>
                }
            </div>
        </div>
    );
};

export default PlayerCard;
